import Vue from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import httpManager from '../../util/common';
import {reportYear, entityOaid} from "../../util/util";
import china_area_code from "../../../static/json/100000_full_geo.json"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false
Vue.use(Antd)
let vm = {
  delimiters: ['{', '}'],
  name: 'supply-chain-area-map',
  // props: ['oaid'],
  data: () => {
    return {
      oaid: null,
      rev_selected: true,
      title_prefix: 'revenue',
      name_prefix: 'customer',
      sc_area_info: [],
      sc_area_info_total: [],
      report_year_list: reportYear.report_options,
      year: reportYear.report_year_now,
      province: null,
      province_list: [],
      select_dict: {},
      result_list: [],
      extremum: {max: null, min: null},
      sta_data: {},
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount:3,
        align: 'center',
        layouts: ['PrevPage', 'Number','NextPage'],
        perfect: true,
      },
      SOC: 'CHN',
      province_dict: {'520000': '贵州',
        '540000': '西藏',
        '530000': '云南',
        '500000': '重庆',
        '360000': '江西',
        '340000': '安徽',
        '510000': '四川',
        '350000': '福建',
        '430000': '湖南',
        '420000': '湖北',
        '410000': '河南',
        '330000': '浙江',
        '640000': '宁夏',
        '650000': '新疆',
        '440000': '广东',
        '370000': '山东',
        '450000': '广西',
        '630000': '青海',
        '320000': '江苏',
        '140000': '山西',
        '460000': '海南',
        '310000': '上海',
        '110000': '北京',
        '130000': '河北',
        '230000': '黑龙江',
        '220000': '吉林',
        '210000': '辽宁',
        '150000': '内蒙古',
        '120000': '天津',
        '620000': '甘肃',
        '610000': '陕西',
        '710000': '台湾',
        '810000': '香港',
        '820000': '澳门',
        'CHN': '境内',
        'overseas': '境外'
      },
      GDPSpeed: {},
      divloading: false,
      map: null, // 地图
      geo_layer: null,  // 地域块对象
      info_control: null, //地图右上角信息控件
    }
  },
  mounted () {
    this.getOaid()
    this.getYear(15)
  },
  watch: {
    year: function () {
      if (this.year) {
        this.getSCAreaProvinceList()
        this.getSCAreaMapData()
        this.getSCAreaData()
        if (this.province) {
          this.sta_data = this.region_dict[this.year][this.province]
        } else {
          this.sta_data = {amount_cny: 0, exp_e: null, yoy: null}
        }
      }
      // this.getSCAreaData()
    },
    province: function () {
      if (this.province) {
        this.sta_data = this.region_dict[this.year][this.province]
        this.getSCAreaData()
      } else {
        this.sta_data = {amount_cny: 0, exp_e: null, yoy: null}
        this.page.total = 0
        this.sc_area_info = []
      }
    }
  },
  methods: {
    getYear(n) {
      const arr = []
      const date = new Date()
      const curDate = date.getFullYear()
      for (let i = 0; i < n; i++) {
        arr.push({ label:curDate - i + '', value: curDate - i})
      }
      this.report_year_list = arr
    },
    getOaid(){
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
        self.getSCRegionData()
      })
    },
    getSCRegionData () {
      let self = this
      self.divloading = true
      let oaid = this.oaid
      let params = new Map()
      params.set('oaid', oaid)
      let command = 'supplier'
      if (this.rev_selected) {
        command = 'customer'
      }
      params.set('type', command)
      httpManager('entity_sc_region', params)
        .then(response => {
          if (response.data.data.result.length > 0) {

            self.select_dict = {}
            self.region_dict = {}
            self.result_list = response.data.data.result
            let currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            for (let i = 0; i < response.data.data.result.length; i++) {
              let data = response.data.data.result[i]
              if (data.reporting_year > currentYear) {
                continue
              }
              let region = null
              if (data.region) {
                region = data.region
              } else {
                if (data.country === 'CHN') {
                  region = 'CHN'
                } else {
                  region = 'overseas'
                }
              }
              if (self.select_dict.hasOwnProperty(data.reporting_year)) {
                self.select_dict[data.reporting_year].push(region)
                self.region_dict[data.reporting_year][region] = {
                  'amount_cny': data.amount_cny,
                  'yoy': data.yoy,
                  'exp_e': data.exp_e
                }
              } else {
                self.select_dict[data.reporting_year] = [region]
                self.region_dict[data.reporting_year] = {}
                self.region_dict[data.reporting_year][region] = {
                  'amount_cny': data.amount_cny,
                  'yoy': data.yoy,
                  'exp_e': data.exp_e
                }

              }
            }
            let yearList = []
            for (let i = 0; i < response.data.data.result.length; i++) {
              let data = response.data.data.result[i]
              if (data.reporting_year >= currentYear) {
                continue
              }
              yearList.push(data.reporting_year)
            }
            self.year = yearList[0]
          }
          self.getSCAreaProvinceList()
          self.getSCAreaMapData()
          self.divloading = false
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },
    getSCAreaProvinceList () {
      this.province_list = this.select_dict[this.year]
      if (this.province_list) {
        this.province = this.province_list[0]
      } else {
        this.province = null
      }
    },
    changeAreaSelected (command) {
      if (command === 'customer') {
        this.rev_selected = true
        this.title_prefix = 'revenue'
        this.name_prefix = 'customer'
      } else {
        this.rev_selected = false
        this.title_prefix = 'cost'
        this.name_prefix = 'supplier'
      }
      this.getSCRegionData()
      // this.getSCAreaProvinceList()
      // this.getSCAreaMapData()
      this.getSCAreaData()
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    },
    getSCAreaData () {
      let self = this
      let oaid = this.oaid
      let params = new Map()
      params.set('oaid', oaid)
      if (!this.year || !this.province) {
        return
      }
      params.set('year', this.year)
      let region = null
      if (this.province === 'overseas') {
        params.set('country', 'overseas')
      } else if (this.province === 'CHN') {
        params.set('country', 'CHN')
      } else {
        params.set('region', this.province)
      }
      params.set('region', this.province)
      let command = 'supplier'
      if (this.rev_selected) {
        command = 'customer'
      }
      let pathVars = new Map()
      pathVars.set('type', command)
      httpManager('sc_bar_data', params, null, null, pathVars)
        .then(response => {
          self.page.total = response.data.data.length
          self.sc_area_info_total = response.data.data
          self.sc_area_info = response.data.data.slice(0, self.page.pagesize)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSCAreaMapData () {
      let self = this
      self.GDPSpeed = {}
      if (self.result_list.length > 0) {
        self.extremum['max'] = 0
        let i = 0
        for (i = 0; i < self.result_list.length; i++) {
          if (self.result_list[i]['reporting_year'] === self.year) {
            self.GDPSpeed[self.result_list[i]['region']] = self.result_list[i]['amount_cny']
            if (self.result_list[i]['amount_cny'] > self.extremum['max']) {
              self.extremum['max'] = self.result_list[i]['amount_cny']
            }
          }
        }
      }

      this.leafletMap ()
    },
    leafletMap () {
      if( !this.map ) {
        this.map = L.map('supply-chain-area-map', {
          center: [35, 110],
          zoom: 3,
          zoomControl: false,
          doubleClickZoom: false,
          fillColor: '#fff',
          fill: '#fff',
        })
        this.initInfoControl()
        this.info_control.addTo(this.map)
      } else {
        this.map.removeLayer(this.geo_layer)
      }
      this.geo_layer = L.geoJSON(china_area_code, {
        style: this.style,
        onEachFeature: this.onEachFeature
      }).addTo(this.map)
    },
    // 地图获取颜色，在style中调用
    getColor(adcode) {
      let color = '#fff'
      let gdp = this.GDPSpeed[adcode]
      if (gdp) {
        let rg = 255 - Math.ceil(gdp * 20 / this.extremum['max']) * 255 / 20
        color = 'rgb(255,' + rg + ',' + rg + ')'
      }
      return color;
    },
    // 地图获取样式
    style(feature) {
      return {
        fillColor: this.getColor(feature.properties.adcode),
        weight: 2,
        opacity: 1,
        color: '#7e7e7b',
        dashArray: '3',
        fillOpacity: 1
      }
    },
    // 初始化地图右上角信息控件
    initInfoControl() {
      this.info_control = L.control()
      this.info_control.onAdd = function(map) {
        this._div = L.DomUtil.create('div', 'map-info'); // create a div with a class "info"
        this.update();
        return this._div;
      }
      this.info_control.update = function(props) {
        let name = props? props.name : "中华人民共和国"
        this._div.innerHTML = '<h4>China</h4>' +
          '<b>' + name +'</b><br />'
      }
    },
    // 地图相关事件
    onEachFeature(feature, layer) {
      layer.on({
        mouseover: this.highlightFeature,
        mouseout: this.resetHighlight,
        click: this.zoomToFeature
      })
    },
    // 地图触碰高亮，在onEachFeature中调用
    highlightFeature(e) {
      var layer = e.target

      layer.setStyle({
        weight: 3,
        color: '#fff',
        dashArray: '',
        fillOpacity: 0.7
      })
      if(!L.Browser.ie && !L.Browser.opera && !L.Browser.edge){
        layer.bringToFront()
      }

      this.info_control.update(layer.feature.properties)
    },
    // 地图移除高亮，在onEachFeature中调用
    resetHighlight(e) {
      this.geo_layer.resetStyle(e.target);
      this.info_control.update()
    },
    // 地图点击放大板块，在onEachFeature中调用
    zoomToFeature(e) {
      this.map.fitBounds(e.target.getBounds())
    },
  }
}
Vue.component('supply-chain-area-map', vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/supply_chain_area_map.js